// extracted by mini-css-extract-plugin
export var banner = "_2c-0";
export var icon = "_2c-1";
export var message = "_2c-2";